import React from "react"

export default function Info() {
  return (
    <symbol id="svg-info" viewBox="0 0 32 32">
      <path
        fill="currentColor"
        d="M15.2 6.3c-5.5 0-9.8 4.4-9.8 9.8S9.8 26 15.2 26s9.8-4.4 9.8-9.8-4.3-9.9-9.8-9.9zm0 17.9c-4.5 0-8.1-3.6-8.1-8.1S10.7 8 15.2 8s8.1 3.6 8.1 8.1-3.6 8.1-8.1 8.1zm.9-8.1v3.6c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-3.6c0-.5.4-.9.9-.9s.9.4.9.9zm-.3-4.2c.2.2.3.4.3.6s-.1.5-.3.7c-.1.1-.3.2-.6.2H15c-.1 0-.1 0-.2-.1-.1 0-.1-.1-.2-.1s-.1-.1-.1-.1c-.1-.1-.2-.3-.2-.6s.1-.4.3-.6l.1-.1c.1 0 .1-.1.2-.1s.1 0 .2-.1c.2 0 .6.1.7.3z"
      />
    </symbol>
  )
}
